import { create } from "zustand";
import type { ParticipantInfo } from "@/services/module/auth";

export const USER_INFO_STORAGE_KEY = "loginUserInfo";

type AuthState = {
  userInfo?: ParticipantInfo;
  setUserInfo: (userInfo?: ParticipantInfo) => void;
};

function readUserInfoFromStorage(): ParticipantInfo | undefined {
  const raw = window.localStorage.getItem(USER_INFO_STORAGE_KEY);
  if (!raw) return undefined;

  try {
    return JSON.parse(raw) as ParticipantInfo;
  } catch {
    return undefined;
  }
}

export const useAuthStore = create<AuthState>()((set) => ({
  userInfo: readUserInfoFromStorage(),
  setUserInfo: (data) => {
    if (data) {
      window.localStorage.setItem(USER_INFO_STORAGE_KEY, JSON.stringify(data));
    } else {
      window.localStorage.removeItem(USER_INFO_STORAGE_KEY);
    }
    set({ userInfo: data });
  },
}));

export function isSuperAdminFlag(isAdmin?: boolean) {
  return isAdmin === true;
}

export function isSuperAdminUser(userInfo?: ParticipantInfo) {
  const info = userInfo ?? readUserInfoFromStorage();
  return isSuperAdminFlag(info?.isAdmin);
}

export function getSystemDefaultPath() {
  return isSuperAdminUser() ? "/system/userDebug" : "/system/copywritingStyle";
}
